import { http, unwrapApiResponse } from './http'

export async function fetchMyCloudDevices() {
  const response = await http.get('/v1/users/devices/select')
  return unwrapApiResponse(response)
}

export async function fetchCloudDevice(deviceId) {
  const response = await http.get(`/v1/users/devices/select/${deviceId}`)
  return unwrapApiResponse(response)
}

export async function createCloudPhoneSession(deviceId) {
  const response = await http.post(`/v1/users/devices/session/${deviceId}`)
  return unwrapApiResponse(response)
}

export async function renameCloudDevice(deviceId, deviceName) {
  return unwrapApiResponse(await http.post(`/v1/users/devices/rename/${deviceId}`, { deviceName }))
}

export async function restartCloudDevice(deviceId) {
  return unwrapApiResponse(await http.post(`/v1/users/devices/restart/${deviceId}`))
}

export async function resetCloudDevice(deviceId) {
  return unwrapApiResponse(await http.post(`/v1/users/devices/oneClickReset/${deviceId}`))
}

export async function redeemActivationCode(code, deviceId = null) {
  return unwrapApiResponse(await http.post('/v1/users/activationCodeRedeem', { code, deviceId }))
}

export async function initCloudDeviceFileUpload(deviceId, file) {
  const isApk = file.name.toLowerCase().endsWith('.apk')
  const response = await http.post(`/v1/users/devices/${deviceId}/files/initUpload`, {
    originalName: file.name,
    fileType: isApk ? 'APK' : 'FILE',
    action: isApk ? 'INSTALL' : 'UPLOAD',
    totalSize: file.size,
    contentType: file.type || null
  })

  return unwrapApiResponse(response)
}

export async function uploadCloudDeviceFileChunk(uploadId, file, offset, length, onProgress, signal) {
  const formData = new FormData()
  formData.append('file', file.slice(offset, offset + length), file.name)

  const response = await http.post(`/v1/users/devices/files/${uploadId}/chunk`, formData, {
    params: { offset },
    onUploadProgress: onProgress,
    signal
  })

  return unwrapApiResponse(response)
}

export async function completeCloudDeviceFileUpload(uploadId) {
  const response = await http.post(`/v1/users/devices/files/${uploadId}/complete`)
  return unwrapApiResponse(response)
}

export async function fetchCloudDeviceFileUpload(uploadId) {
  const response = await http.get(`/v1/users/devices/files/${uploadId}`)
  return unwrapApiResponse(response)
}

export async function cancelCloudDeviceFileUpload(uploadId) {
  const response = await http.delete(`/v1/users/devices/files/${uploadId}`)
  return unwrapApiResponse(response)
}
